function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7147",
  "data-name": "Group 7147",
  transform: "translate(-76.06 -89.069)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Worker_3856238",
  transform: "translate(137.618 89.069)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3409",
  "data-name": "Path 3409",
  d: "M67.347,62.911c-12,0-21.765-10.277-21.765-22.911H41c0,15.159,11.819,27.493,26.347,27.493S93.7,55.159,93.7,40H89.113C89.113,52.633,79.349,62.911,67.347,62.911Z",
  transform: "translate(-11.216 5.826)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3410",
  "data-name": "Path 3410",
  d: "M39.291,41.24H96.568a2.291,2.291,0,0,0,2.291-2.291v-6.6a2.294,2.294,0,0,0-.727-1.675L96.3,28.968A26.18,26.18,0,0,0,81.2,5.943V4.863A5.1,5.1,0,0,0,75.9,0H59.96a5.107,5.107,0,0,0-5.307,4.867V5.954a26.194,26.194,0,0,0-15.1,23.013l-1.83,1.709A2.3,2.3,0,0,0,37,32.351v6.6a2.291,2.291,0,0,0,2.291,2.291ZM67.93,18.329a2.291,2.291,0,1,1-2.291,2.291,2.291,2.291,0,0,1,2.291-2.291ZM41.582,33.346l1.823-1.7a2.293,2.293,0,0,0,.723-1.815A21.578,21.578,0,0,1,57.822,9.56a2.292,2.292,0,0,0,1.413-2.117l0-2.557a.846.846,0,0,1,.727-.3h5.678v9.565a6.873,6.873,0,1,0,4.582,0V4.583H75.9a.888.888,0,0,1,.722.281v2.57A2.291,2.291,0,0,0,78.036,9.55,21.35,21.35,0,0,1,91.731,29.827a2.291,2.291,0,0,0,.723,1.816l1.823,1.7v3.312h-52.7Z",
  transform: "translate(-11.798 0.004)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3411",
  "data-name": "Path 3411",
  d: "M21.873,132.733a2.294,2.294,0,0,1-2.291-2.291V86.449c0-2.678,2.785-5.959,5.307-7.153l19.895-7.2V84.62h4.582s.026-14.031,0-14.167l3.88-1.42L64.509,84.62h5.652L55.948,64.95a2.3,2.3,0,0,0-2.637-.813L23.235,75.021q-.088.032-.173.07C19.1,76.9,15,81.647,15,86.449v43.993a6.881,6.881,0,0,0,6.873,6.873H35.1a13.682,13.682,0,0,1-2.755-4.582Z",
  transform: "translate(-15 9.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3412",
  "data-name": "Path 3412",
  d: "M111.946,75.092q-.085-.038-.173-.07L81.7,64.136a2.3,2.3,0,0,0-2.637.813L64.848,84.62H70.5L81.762,69.033l3.922,1.42c-.026.137-.042,14.167-.042,14.167h4.582V72.1l19.895,7.2c2.522,1.194,5.307,4.475,5.307,7.153v43.993a2.294,2.294,0,0,1-2.291,2.291H102.661a13.682,13.682,0,0,1-2.755,4.582h13.229a6.881,6.881,0,0,0,6.873-6.873V86.449C120.008,81.647,115.909,76.9,111.946,75.092Z",
  transform: "translate(-7.745 9.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3413",
  "data-name": "Path 3413",
  d: "M108.965,88.443A6.95,6.95,0,0,0,103.554,86H34.933a6.739,6.739,0,0,0-6.787,8.239l6.273,32.5a9.337,9.337,0,0,0,8.917,7.373H95.15a9.337,9.337,0,0,0,8.917-7.373l6.273-32.5a6.973,6.973,0,0,0-1.375-5.8Zm-3.124,4.929-6.273,32.5a4.754,4.754,0,0,1-4.417,3.659H43.336a4.754,4.754,0,0,1-4.417-3.659s-6.255-32.405-6.273-32.5a2.238,2.238,0,0,1,2.287-2.789h68.621a2.224,2.224,0,0,1,2.287,2.789Z",
  transform: "translate(-13.111 12.521)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_262",
  "data-name": "Ellipse 262",
  cx: 2.291,
  cy: 2.291,
  r: 2.291,
  transform: "translate(53.841 120.287)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_forms_1236251",
  transform: "translate(261.068 169.526)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3398",
  "data-name": "Path 3398",
  d: "M65.651,22.818a1.451,1.451,0,0,0-.413-1.016L48.6,4.835A1.451,1.451,0,0,0,47.56,4.4H22.534a7.254,7.254,0,0,0-7.254,7.254v51.67a7.254,7.254,0,0,0,7.254,7.254H58.4a7.254,7.254,0,0,0,7.254-7.254ZM48.895,9.267l12.542,12.8H51.071a2.176,2.176,0,0,1-2.176-2.176Zm9.5,58.409H22.534a4.352,4.352,0,0,1-4.352-4.352V11.632A4.352,4.352,0,0,1,22.534,7.28H45.993V19.887a5.078,5.078,0,0,0,5.078,5.078H62.75V63.324A4.352,4.352,0,0,1,58.4,67.676Z",
  transform: "translate(-15.28 -4.4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3399",
  "data-name": "Path 3399",
  d: "M61.55,48.26H42a1.451,1.451,0,1,0,0,2.9H61.55a1.451,1.451,0,1,0,0-2.9Z",
  transform: "translate(-22.219 -16.444)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3400",
  "data-name": "Path 3400",
  d: "M29.676,47.26a2.176,2.176,0,1,0,0,4.352h.036a2.176,2.176,0,1,0-.036-4.352Z",
  transform: "translate(-18.636 -16.17)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3401",
  "data-name": "Path 3401",
  d: "M61.55,61.26H42a1.451,1.451,0,1,0,0,2.9H61.55a1.451,1.451,0,1,0,0-2.9Z",
  transform: "translate(-22.219 -20.014)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3402",
  "data-name": "Path 3402",
  d: "M29.676,60.26a2.176,2.176,0,1,0,0,4.352h.036a2.176,2.176,0,1,0-.036-4.352Z",
  transform: "translate(-18.636 -19.74)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3403",
  "data-name": "Path 3403",
  d: "M61.55,74.26H42a1.451,1.451,0,1,0,0,2.9H61.55a1.451,1.451,0,1,0,0-2.9Z",
  transform: "translate(-22.219 -23.584)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3404",
  "data-name": "Path 3404",
  d: "M29.676,73.26a2.176,2.176,0,1,0,0,4.352h.036a2.176,2.176,0,1,0-.036-4.352Z",
  transform: "translate(-18.636 -23.309)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_forms_1236251-2",
  "data-name": "noun_forms_1236251",
  transform: "translate(76.06 169.526)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3398-2",
  "data-name": "Path 3398",
  d: "M65.651,22.818a1.451,1.451,0,0,0-.413-1.016L48.6,4.835A1.451,1.451,0,0,0,47.56,4.4H22.534a7.254,7.254,0,0,0-7.254,7.254v51.67a7.254,7.254,0,0,0,7.254,7.254H58.4a7.254,7.254,0,0,0,7.254-7.254ZM48.895,9.267l12.542,12.8H51.071a2.176,2.176,0,0,1-2.176-2.176Zm9.5,58.409H22.534a4.352,4.352,0,0,1-4.352-4.352V11.632A4.352,4.352,0,0,1,22.534,7.28H45.993V19.887a5.078,5.078,0,0,0,5.078,5.078H62.75V63.324A4.352,4.352,0,0,1,58.4,67.676Z",
  transform: "translate(-15.28 -4.4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3399-2",
  "data-name": "Path 3399",
  d: "M61.55,48.26H42a1.451,1.451,0,1,0,0,2.9H61.55a1.451,1.451,0,1,0,0-2.9Z",
  transform: "translate(-22.219 -16.444)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3400-2",
  "data-name": "Path 3400",
  d: "M29.676,47.26a2.176,2.176,0,1,0,0,4.352h.036a2.176,2.176,0,1,0-.036-4.352Z",
  transform: "translate(-18.636 -16.17)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3401-2",
  "data-name": "Path 3401",
  d: "M61.55,61.26H42a1.451,1.451,0,1,0,0,2.9H61.55a1.451,1.451,0,1,0,0-2.9Z",
  transform: "translate(-22.219 -20.014)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3402-2",
  "data-name": "Path 3402",
  d: "M29.676,60.26a2.176,2.176,0,1,0,0,4.352h.036a2.176,2.176,0,1,0-.036-4.352Z",
  transform: "translate(-18.636 -19.74)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3403-2",
  "data-name": "Path 3403",
  d: "M61.55,74.26H42a1.451,1.451,0,1,0,0,2.9H61.55a1.451,1.451,0,1,0,0-2.9Z",
  transform: "translate(-22.219 -23.584)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3404-2",
  "data-name": "Path 3404",
  d: "M29.676,73.26a2.176,2.176,0,1,0,0,4.352h.036a2.176,2.176,0,1,0-.036-4.352Z",
  transform: "translate(-18.636 -23.309)"
})));

function SvgStepper1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.38,
    height: 146.634,
    viewBox: "0 0 235.38 146.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper1);
export default __webpack_public_path__ + "static/media/stepper1.b6289f7544430ff61d37894a396c8f44.svg";
export { ForwardRef as ReactComponent };